import useTranslator from "../../hooks/useTranslator";
import { Button } from "../design";

const DataLoadedError = () => {
  const { _t } = useTranslator();
  return (
    <div className="data-loaded-error-wrapper">
      <div className="data-loaded-error">
        <div>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8.99993" cy="8.99993" r="7.99993" fill="#FF3C3C" />
            <path
              d="M9.00045 10.4825C9.18905 10.4825 9.36992 10.4045 9.50328 10.2656C9.63664 10.1266 9.71156 9.93823 9.71156 9.74178V5.29737C9.71156 5.10092 9.63664 4.91251 9.50328 4.7736C9.36992 4.63468 9.18905 4.55664 9.00045 4.55664C8.81186 4.55664 8.63098 4.63468 8.49763 4.7736C8.36427 4.91251 8.28935 5.10092 8.28935 5.29737V9.74178C8.28935 9.93823 8.36427 10.1266 8.49763 10.2656C8.63098 10.4045 8.81186 10.4825 9.00045 10.4825ZM9.00045 13.4454C9.17626 13.4454 9.34811 13.3911 9.49429 13.2894C9.64046 13.1877 9.75439 13.0431 9.82167 12.8739C9.88895 12.7047 9.90655 12.5185 9.87225 12.3389C9.83796 12.1593 9.7533 11.9943 9.62899 11.8648C9.50467 11.7353 9.34629 11.6471 9.17386 11.6114C9.00144 11.5757 8.82271 11.594 8.66029 11.6641C8.49787 11.7342 8.35905 11.8529 8.26138 12.0051C8.1637 12.1574 8.11157 12.3364 8.11157 12.5195C8.11157 12.7651 8.20522 13.0006 8.37192 13.1743C8.53862 13.3479 8.76471 13.4454 9.00045 13.4454Z"
              fill="white"
            />
          </svg>

          <h1>{_t("dataCouldNotBeLoaded")}</h1>
          <p>{_t("somethingWentWrongWhileLoadingThisTable")}</p>
          <Button
            variant="primary"
            size="md"
            onClick={() => window.location.reload()}
          >
            {_t("retry")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DataLoadedError;
